import { DeleteIcon, PenIcon } from "assets/icons";
import { If } from "components";
import { isEmptyValue } from "helpers";
import { useBoolean } from "hooks";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import AutosizeInput from "react-input-autosize";
import { Checkbox, Error, Icon } from "ui";

import { AttributeFieldWrapperProps } from "./AttributeFieldWrapper.types";

import styles from "./AttributeFieldWrapper.module.scss";

const AttributeFieldWrapper = ({
  children,
  value,
  onChange,
  onDelete,
  errorMessage,
  disabledMainFilter,
  readOnly = true
}: AttributeFieldWrapperProps) => {
  const { t } = useTranslation();
  const { name, isMain } = value;
  const isEmptyName = isEmptyValue(name);

  const { name: errorName } = errorMessage ?? {};

  const onChangeField = (fieldKey: string, fieldValue: string | boolean) => {
    onChange({
      ...value,
      [fieldKey]: fieldValue
    });
  };

  const inputRef = useRef<HTMLInputElement | null>(null);

  const {
    value: isFocusedName,
    setTrue: setFocusName,
    setFalse: setBlurName
  } = useBoolean(false);

  const onFocusName = () => {
    inputRef.current?.focus();
  };

  return (
    <div className={styles.attribute}>
      <div className={styles.attribute__header}>
        <div>
          <div className={styles["attribute__header--title"]}>
            {readOnly ? (
              <h2 className={styles["attribute__header--title-input"]}>
                {t(name)}
              </h2>
            ) : (
              <>
                <AutosizeInput
                  inputRef={(ref) => (inputRef.current = ref)}
                  inputClassName={styles["attribute__header--title-input"]}
                  placeholder={t("Enter attribute title")}
                  value={name}
                  onChange={(e) => onChangeField("name", e.target.value)}
                  readOnly={readOnly}
                  autoFocus={isFocusedName || isEmptyName}
                  maxLength={50}
                  onFocus={setFocusName}
                  onBlur={setBlurName}
                />
              </>
            )}

            <If condition={!isFocusedName && !isEmptyName && !readOnly}>
              <Icon
                as={PenIcon}
                type="button"
                boxSize={14}
                color="#595961"
                onClick={onFocusName}
              />
            </If>
          </div>
          <Error message={errorName?.message} />
        </div>
        <div className={styles["attribute__header--actions"]}>
          <Checkbox
            checked={isMain}
            label={t("Main filter")}
            onChange={(e) => onChangeField("isMain", e.target.checked)}
            disabled={disabledMainFilter && !isMain}
          />

          <If condition={onDelete}>
            <Icon
              as={DeleteIcon}
              type="button"
              color="#A8A8BB"
              boxSize={24}
              onClick={onDelete}
              isDisabled={value.isValidToDelete === false}
            />
          </If>
        </div>
      </div>
      {children}
    </div>
  );
};

export default AttributeFieldWrapper;
